import { Config } from 'config';

/* eslint-disable perfectionist/sort-objects */
export const URL = {
  LOGIN: `v1/authentication/login`,
  LOGOUT: `v1/authentication/logout`,
  REFRESH: `v1/authentication/refresh`,

  MOCK_LIST: 'v1/mock',
  MOCK_DETAILS: 'v1/mock/:id',

  // appointment
  APPOINTMENT_LIST: 'v1/appointment',

  // cities
  GET_CITIES: 'v1/cities',

  // get geolocation info
  GET_GEOLOCATION: `https://maps.googleapis.com/maps/api/geocode/json?latlng=:latitude,:longitude&key=${Config.googleKey}&region=us&result_type=locality&language=en`,
};
